import { render, staticRenderFns } from "./form-indirect.vue?vue&type=template&id=b82fee22&scoped=true"
import script from "./form-indirect.vue?vue&type=script&lang=js"
export * from "./form-indirect.vue?vue&type=script&lang=js"
import style0 from "./form-indirect.vue?vue&type=style&index=0&id=b82fee22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82fee22",
  null
  
)

export default component.exports